import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialProjectInvestigatorState: Dtos.ProjectInvestigator & IRegistrationFormState = {
    id: null,
    personnelId: null,
    personnel: null,
    trialId: null,
    trial: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface IProjectInvestigatorReduxFormState {
    id: IFieldState<number>,
    personnelId: IFieldState<number>,
    personnel: IFieldState<Dtos.Personnel>,
    trialId: IFieldState<number>,
    trial: IFieldState<Dtos.Trial>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>,
    openedModals: IFieldState<string[]>,
}
